import * as angular from "angular";
import {IController, IScope} from "angular";
import {LocationType} from "../../../commons/types/location.type";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";
import * as _ from "lodash";
import {FulfillmentAttemptModel} from "../../models/fulfillment-attempt.model";

export class FulfillmentStepsTableRowComponent implements IController {

  stepId: string;
  step: FulfillmentStepModel;
  displayAsItems?: boolean;
  isSelected: boolean;
  defaultColumnsSize: any;
  columns: any;
  dynamicColumns: any;
  defaultColumnSizes: any;
  dynamicColumnWidthClass: string;
  packageDynamicColumns?: any;
  excludeMode: boolean;
  selectedFulfillmentId: string;
  onFulfillmentSelect: Function;
  onSelect: Function;
  onDispatch: Function;
  onDispatchExternal: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onReset: Function;
  onAssignRoute: Function;
  onAssignResourceAllocation: Function;
  onCompleteManually: Function;
  onAddNote: Function;
  onCreateRoute: Function;
  onCancelStep: Function;
  onCreateVoucher: Function;
  onFilterByType: Function;

  public lastAttempt: FulfillmentAttemptModel;
  public isAtRisk: boolean;
  public locationTypes: typeof LocationType = LocationType;
  public attemptTypes: string[] = [];


  constructor(private $steps, private $scope: IScope, private fulfillmentDialogService: FulfillmentDialogService) {
  }

  $onInit() {
    this._initData();

    if(this.stepId){
      this._bindStepToCtrl();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.step && !changes.step.isFirstChange()) {
      this._initData();
    }

    if (changes.stepId && !changes.stepId.isFirstChange()) {
      if(this.stepId){
        this._bindStepToCtrl();
      }
    }
  }

  public bindOnChanges(changes: angular.IOnChangesObject) {
    if (changes.step && !changes.step.isFirstChange()) {
      this._initData();
    }
    if (changes.stepId && !changes.stepId.isFirstChange()) {
      if(this.stepId){
        this._bindStepToCtrl();
      }
    }
  }


  private _bindStepToCtrl() {
    if (this.stepId) {
      this.$steps(this.stepId).$bindCtrlToId(this.$scope, this, 'step', 'stepId')
    }
  }

  private _initData() {
    this.attemptTypes = [];
    this.isAtRisk = !!this.step?.statusGroups.find((sg: string) => {
      return sg === 'Problem'
    });

    this.lastAttempt = _.find(this.step?.attempts, (a) => {
      return a.referenceId === this.step.referenceId;
    });

    if (this.lastAttempt && this.lastAttempt.status !== 'Aborted' && this.lastAttempt.status !== 'Canceled') {
      if (this.lastAttempt.subType === "ThirdParty") {
        this.attemptTypes.push('External')
      } else {
        this.attemptTypes.push('Internal')
      }
    }
  }

  onViewPods(fulfillmentSteps, event) {
    this.fulfillmentDialogService.identificationsImages(fulfillmentSteps, 'Manage Leg PODs');
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsTableRow', {
    require: {
      fulfillmentStepsTableCtrl: '^fulfillmentStepsTable'
    },
    bindings: {
      stepId: '<',
      step: '<',
      displayAsItems: '<?',
      isSelected: '<?',
      defaultColumnSizes: '<',
      defaultColumnsSize: '<',
      columns: '<',
      dynamicColumns: '<',
      dynamicColumnWidthClass: '<',
      packageDynamicColumns: '<?',
      excludeMode: '<',
      selectedFulfillmentId: '<',
      onFulfillmentSelect: '&',
      onSelect: '&',
      onDispatch: '&',
      onDispatchExternal: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onReset: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onCompleteManually: '&',
      onAddNote: '&',
      onCreateRoute: '&',
      onCancelStep: '&',
      onCreateVoucher: '&',
      onFilterByType: '&'
    },
    template: require('./fulfillment-steps-table-row.html').default,
    controller: FulfillmentStepsTableRowComponent
  });
